import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AverageRiskIcon = props => (
  <Icon viewBox="0 0 720 720" h="full" w="full" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <path
          d="M640.021 60.0211C805.707 60.0211 940.021 194.336 940.021 360.021 940.021 525.707 805.707 660.021 640.021 660.021 474.336 660.021 340.021 525.707 340.021 360.021 340.021 194.336 474.336 60.0211 640.021 60.0211ZM640.021 105.021C499.189 105.021 385.021 219.189 385.021 360.021 385.021 500.854 499.189 615.021 640.021 615.021 780.854 615.021 895.021 500.854 895.021 360.021 895.021 219.189 780.854 105.021 640.021 105.021ZM512.5 337.5 767.5 337.5C779.926 337.5 790 347.574 790 360 790 371.391 781.535 380.805 770.553 382.295L767.5 382.5 512.5 382.5C500.074 382.5 490 372.426 490 360 490 348.609 498.465 339.195 509.447 337.705L512.5 337.5 767.5 337.5 512.5 337.5Z"
          fill="#F8B810"
          fillRule="nonzero"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
